import { ResourceKind } from "./ResourceKinds";

export interface Resource {
  kind: ResourceKind;
  uri: string;
  description: string;
  missing: boolean;
  resolution?: string | undefined;
  format?: string | undefined;
};


export function getResourceResolution(resource: Resource): string | undefined {
  const descriptions = splitDescriptions(resource);

  let resolution =  descriptions.find(desc => desc.endsWith('x'));

  if (resolution) {
    resolution = resolution.toLocaleLowerCase();
  }

  return resolution;
}


export function getResourceFormat(resource: Resource):string | undefined {
  const descriptions = splitDescriptions(resource);

  let format = descriptions.find(desc => desc.includes("-"));

  if (format?.includes("-")) { 
    return format.split("-")[1];
  }

  return format;

}

function splitDescriptions(resource: Resource): Array<string> {
  return resource.description.split(",").map((desc) => desc.trim());
}